import * as React from 'react';
import { Icon } from '../icons/Icon';
import { cn } from '../../utils';

export interface ApplyExpectedButtonProps {
  /** Pushes the issue's expected value into the input above. */
  onApply: () => void;
  /** aria-label / title for the button. */
  label: string;
  className?: string;
}

/** Arrow-up button that fills an input with a validation issue's expected
 * value. Mirrors the apply affordance on `ExpectedAmountHint`. */
export const ApplyExpectedButton: React.FC<ApplyExpectedButtonProps> = ({
  onApply,
  label,
  className
}) => (
  <button
    type='button'
    // Keep focus on the input: focusing the button would bubble a focus event
    // to the row/line and clear the very issue this button belongs to, removing
    // it before the click registers.
    onMouseDown={e => e.preventDefault()}
    onClick={onApply}
    aria-label={label}
    title={label}
    className={cn(
      'ml-2xs inline-flex shrink-0 items-center rounded p-2xs align-middle transition-colors hover:bg-warn-bg',
      className
    )}
  >
    <Icon name='arrow-up' className='w-3 h-3' />
  </button>
);

ApplyExpectedButton.displayName = 'ApplyExpectedButton';
